import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";

import img1 from "../assets/asset_4.png";
import useWindowDimensions from "../hooks/useWindowDimensions";

const Welcome = () => {
  const { width } = useWindowDimensions();

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#welcome-h", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.2,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#welcome-img", {
        stagger: 0.1,
        opacity: 0,
        xPercent: 5,
      });

      tl.from("#welcome-p", {
        stagger: 0.1,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#welcome-btn", {
        opacity: 0,
        duration: 0.1,
        y: 50,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id="welcome"
      style={{ height: "100%", marginTop: 50, marginBottom: 50 }}
      className={`container ${width > 992 ? "text-left" : "text-center"}`}
    >
      <div className="row justify-content-center">
        <div className={`col-md-auto ${width > 992 ? "order-0" : "order-1"}`}>
          <div
            id="welcome-h"
            style={{
              fontSize: width > 900 ? 70 : 42,
              color: "var(--primary)",
            }}
          >
            <h1 className="primary-h">
              Welcome to <br />
              Gutter Bats <br />
              Planet NFT
            </h1>
          </div>
          <p
            id="welcome-p"
            className="primary-p py-3"
            style={{ textAlign: width > 992 ? "left" : "center" }}
          >
            Join the pride of Gutter Bats Planet Kings,
            <br />
            and explore all the possibilities of the metaverse.
            <br />
            We're on a mission to build the premier Web 3.0
            <br />
            brand together with our community,
            <br />
            driven by our shared passion for NFTs, gaming and the metaverse.
          </p>
          <a
            href="https://discord.gg/Fdsu6PPW"
            target="_blank"
            rel="noferrer"
            style={{ all: "unset" }}
          >
            <button id="welcome-btn" className="primary-btn">
              Join the pride on Discord
              <i
                className="bi bi-discord"
                style={{
                  color: "var(--dark)",
                  marginLeft: 10,
                  cursor: "pointer",
                }}
              />
            </button>
          </a>
        </div>
        <div className={`col-md-auto ${width > 992 ? "order-1" : "order-0"}`}>
          <img
            id="welcome-img"
            className="stroked-img"
            src={img1}
            style={{ width: width > 992 ? "90%" : "75%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
